// extracted by mini-css-extract-plugin
export default {"searches-modal-box-custom":"UserSearches_searches-modal-box-custom__vlgdn"};